import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Chat from "./Pages/Chat";
import Library from "./Components/Library/Library";
import Admin from "./Components/Admin/Admin";
import AddContent from "./Components/AddContent/AddContent";
import { AuthProvider } from "react-oidc-context";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Navigate to="/chat" replace={true} />,
      },
      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "addcontent",
        element: <AddContent />,
      },
      {
        path: "admin",
        element: <Admin />,
      },
      {
        path: "library",
        element: <Library />,
      },
    ],
  },
]);
const onSigninCallback = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
const oidcConfig = {
  client_id: process.env.REACT_APP_CLIENT_ID,
  authority: process.env.REACT_APP_AUTHORITY,
  redirect_uri: window.location.origin + "/chat",
  acr_values: process.env.REACT_APP_ACR_VALUE,
  response_type: "code",
  scope: process.env.REACT_APP_SCOPE,
  automaticSilentRenew: true,
  onSigninCallback,
};
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider {...oidcConfig}>
    <RouterProvider router={router} />
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
